"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidSchemaError = void 0;
var tslib_1 = require("tslib");
/**
 * An error thrown when a marshaller or unmarshaller cannot understand a node of
 * the provided schema.
 */
var InvalidSchemaError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidSchemaError, _super);
    function InvalidSchemaError(node, message) {
        var _this = _super.call(this, message) || this;
        _this.node = node;
        return _this;
    }
    return InvalidSchemaError;
}(Error));
exports.InvalidSchemaError = InvalidSchemaError;
